<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/Master/ManageTransport'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-truck"></i>
            </span>
            <h3 class="kt-portlet__head-title">จัดการข้อมูลขนส่ง</h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit"  ref="searchForm">
            <div class="row">
              <div class="col-xl-8 col-lg-8 col-md-8 .col-sm-8 col-xs-8">
                <div class="form-group">
                  <label>คำค้นหา:</label>
                  <input
                    v-model="MtsKeyword"
                    type="text"
                    class="form-control"
                    placeholder="ระบุคำค้นหา โดยสามารถคั่นระหว่างคำได้ด้วยเครื่องหมายลูกน้ำ เช่น ทะเบียนรถ1, บริษัท1"
                  />
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สถานะ :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'MtsStatus'"
                    :name="'MtsStatus'"
                    :select2-options="MtsStatusOptions"
                    v-model="MtsStatus"
                    ref="MtsStatusSelect2"
                  ></select2>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">ค้นหา</button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <router-link
                  to="ManageTransport/Add"
                  tag="button"
                  title="เพิ่ม"
                  class="btn btn-outline-brand"
                  v-if="
                    this.$root.canShow(['MANAGE_MASTER', 'MANAGE_TRANSPORT'])
                  "
                >
                  <i class="fa fa-plus-circle"></i> เพิ่ม
                </router-link>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->
          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="transportTable"
              >
                <thead>
                  <tr>
                    <!-- <th>รหัสขนส่ง</th> -->
                    <th class="all">ทะเบียนรถ</th>
                    <th class="all">บริษัท</th>
                    <th class="all">ชื่อคนขับ</th>
                    <th class="all">เบอร์ติดต่อ</th>
                    <th class="none">ผู้ประสานงาน</th>
                    <th class="none">เบอร์ติดต่อผู้ประสานงาน</th>
                    <th class="none">อีเมล</th>
                    <th class="all">สถานะ</th>
                    <th class="all">การจัดการ</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import router from "../../../router";
import select2 from "../../../Shared/Select2";
import DatatableWarning from "../../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

let StatusActionsTrue = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-success">
      <i class="fas fa-play"></i>เปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      var table = $("#transportTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่...",
          });

          axios
            .put("/Api/Transport/" + this.data.trasitId + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                Swal.fire("สำเร็จ", response.data.message, "success");
                self.$parent.reloadDataTable();
              } else {
                Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
              }
            })
            .catch(function(error) {
              console.log(error);
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});
let StatusActionsFalse = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-danger">
      <i class="fas fa-pause"></i>ปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      var table = $("#transportTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        Swal.fire("สำเร็จ", "success");
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่...",
          });

          axios
            .put("/Api/Transport/" + this.data.trasitId + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                Swal.fire("สำเร็จ", response.data.message, "success");
                self.$parent.reloadDataTable();
              } else {
                Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
              }
            })
            .catch(function(error) {
              console.log(error);
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});

let Action = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="edit" v-if="data.showEditButton" title="แก้ไข" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-edit"></i>
    </a>
     <a href="#" @click.prevent="deleteTran" v-if="data.showDeleteButton" title="ลบ" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-trash"></i>
    </a>
  </div>`,
  methods: {
    edit: function() {
      router.push({
        path: `/Master/ManageTransport/Edit/${this.data.trasitId}`,
      });
    },
    deleteTran: function() {
      let self = this;
      Swal.fire({
        title: "คำสั่งลบข้อมูลขนส่ง",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งลบข้อมูลขนส่ง <strong>" +
          "</strong> หลังจากลบแล้วจะส่งผลให้ข้อมูลขนส่งนี้ไม่ถูกใช้งาน",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ต้องการลบข้อมูลขนส่ง",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่...",
          });
          axios
            .put("/Api/Transport/" + this.data.trasitId + "/Delete")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});

export default {
  components: {
    select2,
  },
  data: function() {
    return {
      MtsKeyword: "",
      MtsStatus: "",

      MtsStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "false", text: "ใช้งาน", data: null },
          { id: "true", text: "ปิดใช้งาน", data: null },
        ],
      },
    };
  },
  methods: {
    formReset: function(e) {
      this.MtsKeyword = "";

      //default Active Data
      this.MtsStatus = false;
      $("#MtsStatus")
        .val(this.MtsStatus + "")
        .trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#transportTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function(resetPaging = false) {
      $("#transportTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
  },
  async mounted() {
    let self = this;

    //default Active Data
    self.MtsStatus = false;
    $("#MtsStatus")
      .val(self.MtsStatus + "")
      .trigger("change");

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#transportTable");
    // begin first table
    table
      .DataTable({
        // data: dataSet,
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Transport/Search",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            return JSON.stringify(
              $.extend(d, {
                SearchKeyword: self.MtsKeyword,
                InActiveStatus: self.MtsStatus,
              })
            );
          },
        },

        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
      <'row'<'col-sm-12'tr>>
			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },

        // Order settings
        order: [[5, "desc"]],
        select: {
          style: "multi",
          selector: "td:first-child",
        },
        columns: [
          // { data: "trasitId", className: "text-center" },
          { data: "carReg", className: "text-center" },
          { data: "companyName", className: "text-center",
            
            render: function(data, type, full, meta) {
                var html = "<pre style='font-size: 15px; font-weight: 300; font-family: Noto Sans Thai UI;color: #6c7293;display:inline;white-space: pre-wrap; word-break: keep-all;'>"+data+"</pre>";
                return html;
              } 

           },
          { data: "driverName", className: "text-center" },
          { data: "driverTel", className: "text-center" },
          { data: "contactName", className: "text-center" },
          { data: "contactTel", className: "text-center" },
          { data: "contactEmail", className: "text-center" },
          {
            data: "inActiveStatus",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actionsStatus"></div>';
            },
          },
          {
            data: "trasitId",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            },
          },
        ],
      })
      .on("preXhr.dt", function() {
        KTApp.block(self.$refs.searchForm, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("xhr.dt", function() {
        KTApp.unblock(self.$refs.searchForm);
      })
      .on("draw.dt", function() {
        $(".actionsStatus").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditStatusButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MANAGE_TRANSPORT",
            ]);
            if (data.inActiveStatus == false)
              new StatusActionsTrue({ data: { data }, parent: self }).$mount(
                el
              );
            else if (data.inActiveStatus == true)
              new StatusActionsFalse({ data: { data }, parent: self }).$mount(
                el
              );
          }
        });

        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MANAGE_TRANSPORT",
            ]);
            data.showDeleteButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MANAGE_TRANSPORT",
            ]);
            new Action({ data: { data }, parent: self }).$mount(el);
          }
        });
      });
    //table.trigger("draw.dt"); //call ajax delete this row
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Master/Transport/ManageTransport.vue